import React from "react";
import ProductoInicio from "../components/products/ProductoInicio";

const Pizza = () => {
  return (
    <div className="mt-3">
      <ProductoInicio />
    </div>
  );
};

export default Pizza;
